export default __webpack_public_path__ + "391ad3cac44468b736ef947656bfaebb.svg";